import React from 'react';
import { SmartLink } from '../SmartLink/SmartLink';
import './CardTrio.scss';
import { CardTrioCard } from './CardTrioCard';

export interface CardTrioInputs {
    id: string;
    header?: string;
    inline?: boolean;
    cards: CardTrioCard[];
    cta?: {
        title: string;
        uri: string;
    };
    videoChannelLink?: string;
}

export const CardTrio = ({ inputs }: { inputs: CardTrioInputs }) => {
    if (!inputs) return;

    return (
        <section
            className={`paragraph__card_trio ${
                inputs.inline ? `` : `kite-container`
            }`}
        >
            <h2 className={`typestack-title-3`}>
                <span>{inputs.header}</span>
                {inputs.videoChannelLink && (
                    <a
                        href={inputs.videoChannelLink}
                        target="new"
                        title="Go to YouTube Channel"
                    >
                        Go To Youtube Channel
                    </a>
                )}
            </h2>
            <ul>
                {inputs.cards.map((card) => (
                    <CardTrioCard key={card.id} card={card} />
                ))}
            </ul>
            {inputs.cta && (
                <SmartLink button={true} url={inputs.cta.uri}>
                    {inputs.cta.title}
                </SmartLink>
            )}
        </section>
    );
};
